import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import ProfilePage from '@/features/account/profile/profile-page';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

const CONFIRM_TARGETS = ['personal-data', 'email', 'password', 'photo', 'delete-account'] as const;
export type ProfileConfirmTarget = (typeof CONFIRM_TARGETS)[number];

export const Route = createFileRoute('/perfil/')({
  // DEV-555 — `?confirm=<alvo>`: uma página de destino gateada (link direto) devolve
  // a pessoa aqui com a confirmação de identidade aberta.
  validateSearch: (search: Record<string, unknown>): { confirm?: ProfileConfirmTarget } => {
    const confirm = CONFIRM_TARGETS.find((t) => t === search.confirm);
    return confirm ? { confirm } : {};
  },
  component: () => (
    <HomeGate>
      <ProfilePage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
